/* eslint-disable react/prop-types */

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";

const AngleDownIcon = () => <FontAwesomeIcon icon={faAngleDown} />;

export default AngleDownIcon;
